export default "/images/simplepay-payments.png?85412015898c84d0baf82304807afaa0";